"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "IClassNameDescription", {
  enumerable: true,
  get: function get() {
    return _generateClassName.IClassNameDescription;
  }
});
Object.defineProperty(exports, "IClassNameGenerator", {
  enumerable: true,
  get: function get() {
    return _generateClassName.IClassNameGenerator;
  }
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _generateClassName2["default"];
  }
});
var _generateClassName = require("./generateClassName.types");
var _generateClassName2 = _interopRequireDefault(require("./generateClassName"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}